var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('div',{staticClass:"deals-slider-wrapper",class:_vm.$style.wrapper},[_c('VueSlickCarousel',{ref:"carousel",attrs:{"variable-width":"","infinite":false,"arrows":false,"dots":true,"slides-to-scroll":3,"slides-to-show":3,"responsive":[
        {
          breakpoint: 1110,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 740,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
          },
        }
      ]}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }